<template>
  <div v-if="loadingIncident">
    <v-skeleton-loader class="mx-auto" elevation="12" max-width="400" type="list-item-two-line"></v-skeleton-loader>
  </div>
  <div v-else class="d-flex flex-row flex-nowrap py-2">
    <div class="flex-grow-0 align-items d-flex px-2">
      <v-avatar :color="incident?.sfdiLevelColor || incident?.complexity?.color || '#808080'" size="default" class="pa-0">
        <v-icon color="rgb(var(--v-theme-on-background))" size="large">mdi-fire</v-icon>
      </v-avatar>
    </div>

    <div class="d-flex flex-grow-1 flex-column justify-center title-wrapper">
      <p class="titleLarge lh-17 text-truncate">
        {{ incident?.name }}
        <v-tooltip activator="parent" location="start">{{ incident?.name }}</v-tooltip>
      </p>
      <p class="bodyIncident opacity67 over text-truncate">
        {{ incident?.state ? incident?.state : $t('common.concepts.notAvailable') }} · {{ sizeMeassurement ? sizeMeassurement : '-' }}
        {{ $t('domain.units.hectaresShort') }} · {{ containmentMeassurement ? containmentMeassurement : '-' }} %

        <v-tooltip activator="parent" location="start">
          {{ incident?.state ? incident?.state : $t('common.concepts.notAvailable') }} · {{ sizeMeassurement ? sizeMeassurement : '-' }}
          {{ $t('domain.units.hectaresShort') }} · {{ containmentMeassurement ? containmentMeassurement : '-' }} %
        </v-tooltip>
      </p>
    </div>

    <div class="px-1 d-flex flex-nowrap">
      <v-btn-group>
        <v-btn variant="plain" icon density="compact" @click="pinOrUnpin()">
          <v-icon>{{ isPinned ? 'mdi-pin-off' : 'mdi-pin' }}</v-icon>
          <v-tooltip activator="parent" location="bottom">
            {{ isPinned ? $t('common.actions.unpin') : $t('common.actions.pin') }}
          </v-tooltip>
        </v-btn>
        <v-btn variant="plain" icon density="compact" @click="goToExtent()">
          <v-icon>mdi-map-marker</v-icon>
          <v-tooltip activator="parent" location="bottom">{{ $t('common.actions.locate') }}</v-tooltip>
        </v-btn>
        <v-btn variant="plain" icon size="default" density="compact" @click="closeFeature()">
          <v-icon>mdi-close</v-icon>
          <v-tooltip activator="parent" location="bottom">{{ $t('common.actions.close') }}</v-tooltip>
        </v-btn>
      </v-btn-group>
    </div>
  </div>
</template>

<script setup lang="ts">
//import Framework
import { computed } from 'vue'

import { storeToRefs } from 'pinia'

//import Composables

//import Karonte
import useView from '@tsyl/karonte/lib/composables/useView'
import type { Coordinates } from '@tsyl/karonte/lib/types/coordinates'
import { useQueryNavigation } from '@tsyl/vueabuse'

//import Components

//import Composables
import getMeassurementData from '@/composables/getMeassurementData'

//import Store

import IncidentStore from '@/stores/incidentStore.ts'
import { incidentsPinnedStore } from '@/stores/pinnedIncidents'
import { transformIncidentApiToZIncident } from '@/utils/incidentTools'

const { getReactiveView } = useView()

const incidentStore = IncidentStore()
const { incident, loadingIncident } = storeToRefs(incidentStore)

const { removeQueryValue } = useQueryNavigation()

const view = getReactiveView()

function goToExtent() {
  const coordinates: Coordinates = {
    latitude: incident.value?.latitude as number,
    longitude: incident.value?.longitude as number
  }

  view.value?.goTo(coordinates, 17)
}

const { pinned } = storeToRefs(incidentsPinnedStore())

const isPinned = computed(() => {
  return pinned.value.some((p) => p.id === incident.value?.id)
})

const sizeMeassurement = getMeassurementData(incident.value!, 'Size')
const containmentMeassurement = getMeassurementData(incident.value!, 'Containment')

function pinOrUnpin() {
  if (isPinned.value) {
    unPinIncident()
  } else {
    pinIncident()
  }
}

function pinIncident() {
  const pinnedIncident = transformIncidentApiToZIncident(incident.value!)
  pinned.value.push(pinnedIncident)
}

function unPinIncident() {
  pinned.value = pinned.value.filter((i) => {
    return i.id !== incident.value?.id
  })
}

function closeFeature() {
  removeQueryValue(['incident'])
}
</script>

<style lang="scss" scoped>
.lh-17 {
  line-height: 17px;
}

.title-wrapper {
  min-width: 0px;
}

#main_icon_header {
  padding-right: 0 !important;
  padding-left: 16px !important;
}
</style>
